import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import Input from '@hobs/components/Input';
import { required } from '@hobs/validations';
import { RaisedButton } from '@hobs/components/Buttons';
import Styles from './LoginTokenForm.module.scss';

const emailCounterSeconds = 10;

const LoginTokenForm = (props) => {
  const [emailResendCounter, setEmailResetCounter] = useState(0);
  const [emailCounterEnabled, setEmailCounterEnabled] = useState(true);
  const [isAccountLocked, setIsAccountLocked] = useState(false);
  const [emailResendText, setEmailResendText] = useState(emailCounterSeconds);

  useEffect(() => {
    props.onResendEmail();
    startEmailCounter(emailCounterSeconds);
  }, []);

  async function onResendEmail() {
    setEmailCounterEnabled(false);
    const result = await props.onResendEmail();

    if (!result.success) {
      return;
    }

    setEmailCounterEnabled(true);
    startEmailCounter(emailCounterSeconds);
  }

  function startEmailCounter(counter) {
    counter--;
    if (counter > 0) {
      setEmailResetCounter(counter);
      setEmailResendText(counter);

      setTimeout(() => startEmailCounter(counter), 1000);
    }
    else {
      setEmailResetCounter(0);
      setEmailResendText(props.translations.resendEmail);
    }
  }

  function tokenValidation(value) {
    const { translations } = props;

    if (required()(value)) {
      return required(translations.validation.tokenRequired)(value);
    }

    if (value.length > 10) {
      return 'Verification code is too long';
    }

    return false;
  };

  async function onSubmit(values, actions) {
    const results = await props.onSubmit(values.token);

    if (results && !results.success) {
      setIsAccountLocked(results.lockoutEnabled);
      actions.setErrors({
        token: true,
        form: results.message || 'Verification code is incorrect or has expired. Please try again'
      });
    }

    actions.setSubmitting(false);
  };


  const { translations } = props;
  return (
    <div className={Styles.form}>
      <Formik
        validateOnBlur={false}
        validateOnChange={false}
        initialValues={{
          token: '',
          form: null
        }}
        onSubmit={onSubmit}
      >
        {({ isSubmitting }) => (
          <Form>
            <Field
              name="token"
              validate={tokenValidation}
              component={Input}
              large
            >
              {translations.token}
            </Field>

            <ErrorMessage
              name="form"
              render={msg => (
                <div data-api-error className={Styles['error-label']}>
                  {msg}
                </div>
              )}
            />

            <div className={Styles.buttons}>
              <RaisedButton large type="submit" disabled={isSubmitting || isAccountLocked}>
                {translations.login}
              </RaisedButton>
              <RaisedButton
                large
                type="button"
                disabled={isSubmitting || isAccountLocked || !emailCounterEnabled || emailResendCounter > 0}
                onClick={() => onResendEmail()}
              >
                {emailResendText}
              </RaisedButton>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}

LoginTokenForm.propTypes = {
  onSubmit: PropTypes.func,
  onResendEmail: PropTypes.func,
  translations: PropTypes.object
};

export default LoginTokenForm;
